import React from 'react'

export const Footer = () => {
    return (
        <>
            <div className="container-fluid footC bg-primary text-white text-center">
                <p>Copyright &copy; Sujal Modanwal </p>
                <div>
                    <a href="https://github.com/sujal-ux/SQL-Editor"><i className="fa-brands fa-github"></i></a>
                    <a href="mailto:sumo12082000@gmail.com"><i className="fa fa-envelope"></i></a>

                </div>
            </div>
        </>
    )
}
